import React, {useState, useEffect} from 'react'
import { useTranslation } from "react-i18next";
import { LIMIT_PAGE } from "constants/variables";
import Box from '@mui/material/Box';  
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import EditIcon from '@mui/icons-material/Edit';
import Icon from '@mui/material/Icon'; 
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import TextField from '@mui/material/TextField';
import useTheme from '@mui/material/styles/useTheme';   
import visuallyHidden from '@mui/utils/visuallyHidden';
 import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsColors = [
  {
    id: 'indexrowcolors',
    numeric: true,
    disablePadding: false,
    label: 'Text_Row',
    canOrder:true,
  },
  {
    id: 'enablecolorarticle',
    numeric: false,
    disablePadding: false,
    label: 'Text_EnableColorArticle',
    canOrder:false,
  },
  {
    id: 'color_codehex',
    numeric: false,
    disablePadding: false,
    label: 'Text_ColorArticle_Show',
    canOrder:true,
  },
  {
    id: 'color_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_ColorArticle',
    canOrder:true,
  }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
  
function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
        return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t,roles } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Modify_Colors'))&&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}}>
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        {headCellsColors.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
       
         {roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Delete_Colors'))&&
        <TableCell
          key='delete'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#e74a3b", fontSize: 16}} > 
            {t('Button_Delete')}
          </Typography>
        </TableCell>}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
    const { numTotRegColor, t, roles,setOpenEditNewColor,setOpenEditRowColor,colorToSelect} = props;
    const handleAddNewColor = () => {
        setOpenEditNewColor(false);
        setOpenEditRowColor(true);
    };
    return (
      <Toolbar>
      <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 16}} id="tableTitle" component="div">
        {t('Text_Article_Color')} &nbsp;&nbsp;
        { ((colorToSelect.length-numTotRegColor)>0 && roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Add_Colors')))&&
          <>
            <IconButton
              size="small"  
              style={{color:"#e74a3b", fontSize: 16}}
              onClick={handleAddNewColor}>
               <Icon
                baseClassName="fas"
                className="fa-plus add-icon-button"
              /> 
            </IconButton>&nbsp;&nbsp;
          </>
        }
      </Typography>
      <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 14}} id="tableTitle" component="div">
        {t('Text_Num_Reg')} {(numTotRegColor).toLocaleString('de-DE')} {t('Text_Of')}  {(numTotRegColor).toLocaleString('de-DE')}
      </Typography>
    </Toolbar>
  );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataArticles']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export const TableSortingColors =(props)=>{
  const { dataColors, 
    setFormArticle, 
    numTotRegColor, 
    setOpenDeleteRowColor, 
    setOpenEditNewColor, 
    setOpenEditRowColor, 
    setEditRowColor, 
    roles, 
    colorToSelect,
    formArticle} = props;
  const {t,i18n} = useTranslation(['listDataArticles']);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataColors.length) : 0);
  const [countData,setCountData] = useState(dataColors.length);
  const [activeOffset, setActiveOffset]= useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(1);
  const [rangeOffset, setRangeOffset] = useState([{}]);

    useEffect(() => {
      if (dataColors.length !== countData || dataColors.length <= rowsPerPage) {
        setPage(0);
      }  
      setCountData(dataColors.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataColors.length) : 0);
    }, [dataColors, rowsPerPage, page, countData]);
    
    useEffect(() => {
      if (numTotRegColor > LIMIT_PAGE) {
        setActiveOffset(true);
        const ranges = [
          {
            value: 1,
            label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
          },
        ];
        for (let i = Number(LIMIT_PAGE); i < numTotRegColor; i += Number(LIMIT_PAGE)) {
          ranges.push({
            value: (i / Number(LIMIT_PAGE)) + 1,
            label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
          });
        }
        setRangeOffset(ranges);
      } else {
        setCurrencyOffset(1);
        setActiveOffset(false);
        setRangeOffset([{}]);
      }
    }, [numTotRegColor]);

  const handleChangeOffset = (event) => {
    setCurrencyOffset(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openModalDeleteRowColors = (row) => {
    setEditRowColor(row);
    setOpenDeleteRowColor(true);
  };

  const openEditRowColors = (row) => {
    setEditRowColor(row);
    setOpenEditNewColor(true);
    setOpenEditRowColor(true);
  };

  const handleChangeEnabledArticle = (item) => {
    var i =  dataColors.indexOf( item );
    dataColors.map((item,index)=>{
      if ( index===i ) {
        return item.enablecolorarticle=!item.enablecolorarticle
      } else{
        return item.enablecolorarticle
      }
    })
    setFormArticle(formArticle => ({
       ...formArticle,
    }))
   };

  const listItems= (
  stableSort(dataColors, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keydataColors) => {
    return (
      <TableRow hover tabIndex={-1} key={keydataColors}>
       {(roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Modify_Colors')))&&
        <TableCell align="center">
          <IconButton size="large" className="edit-icon-button" onClick={()=>openEditRowColors(row)}>
            <EditIcon/>
          </IconButton>
        </TableCell>}
        <TableCell align="right">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {row.indexrowcolors}
          </Typography>
        </TableCell>
          <TableCell align="center">
          <Checkbox checked={row.enablecolorarticle} 
            sx={{
              '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
            }} 
            onClick={()=>handleChangeEnabledArticle(row)}/>
        </TableCell>
        <TableCell align="center">
            <Box sx={{ align: 'center', width: 60, height: 15, backgroundColor: row.color_codehex}}/>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {i18n.language==="es"?row.color_namees:row.color_nameen}
          </Typography>
        </TableCell>
        {(roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Delete_Colors'))) &&
        <TableCell align="center">
          <IconButton size="large" className={formArticle.articlestorenumseriales.findIndex(((item) => item.color_id === row.color_id))>=0?"delete-noicon-button":"delete-icon-button"} onClick={()=>openModalDeleteRowColors(row)} disabled={formArticle.articlestorenumseriales.findIndex(((item) => item.color_id === row.color_id))>=0}>
            <DeleteIcon/>
          </IconButton>
        </TableCell>} 
      </TableRow>
    );
  }));
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar numTotRegColor={numTotRegColor} t={t} roles={roles} setOpenEditNewColor={setOpenEditNewColor} setOpenEditRowColor={setOpenEditRowColor} colorToSelect={colorToSelect}/>
         <TableContainer component={Paper} className="formdi-table-container" >
          <Table sx={{ minWidth: '1060px',width: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
            <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t} roles={roles}/>
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={6} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffset && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffset"
                            name="currencyOffset"
                            value={currencyOffset}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffset
                            }}>
                            {rangeOffset.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={12}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingColors.propTypes = {
  dataColors: PropTypes.array.isRequired,
  setFormArticle: PropTypes.func.isRequired, 
  numTotRegColor: PropTypes.number.isRequired,
  setOpenDeleteRowColor: PropTypes.func.isRequired,
  setOpenEditNewColor: PropTypes.func.isRequired,
  setOpenEditRowColor: PropTypes.func.isRequired,
  setEditRowColor: PropTypes.func.isRequired,
  roles: PropTypes.array.isRequired
};

export default TableSortingColors;